export const CueLabelOptions = {
  AMBrushTeeth: "AM Brush Teeth",
  MorningCosmetics: "Morning Cosmetics",
  MorningSkincare: "Morning Skincare",
  MorningShaving: "Morning Shaving",
  AMGettingDressed: "AM Getting Dressed",
  Breakfast: "Breakfast",
  AMCoffee: "AM Coffee",
  AMSpiritualPractice: "AM Spiritual Practice",
  BreakfastDishes: "Breakfast Dishes",
  WalkingTheDog: "Walking the Dog",
  AMWorkout: "AM Workout",
  Lunch: "Lunch",
  PMCoffee: "PM Coffee",
  PMSpiritualPractice: "PM Spiritual Practice",
  PMWorkout: "PM Workout",
  Dinner: "Dinner",
  PMDishes: "PM Dishes",
  EveningTVRadio: "Evening TV Radio",
  Pajamas: "Pajamas",
  EveningReading: "Evening Reading",
  EveningSkincare: "Evening Skincare",
  EveningShaving: "Evening Shaving",
  EveningCosmetics: "Evening Cosmetics",
  PMBrushTeeth: "PM Brush Teeth",
  SettingAlarm: "Setting Alarm",
  Other: "Other",
} as const;